module.exports = __webpack_public_path__ + "static/media/Add-Accent.df0fc26d.svg";